import "./App.css";
import { Route, Routes } from "react-router-dom";
import Store from "pages/Store";
import Review from "pages/Review";
import Header from "components/Header";
import Container from "components/common/Container";
import { MENU_TYPES } from "models/business.model";
import React from "react";
import { convertMenuTypeToStoreType, extractSubType } from "utils/converter";

function App() {
  return (
    <div className="App">
      <Header />
      <Container>
        <Routes>
          {MENU_TYPES.map((menuType) => (
            <React.Fragment key={menuType}>
              <Route
                key={`${menuType}-store`}
                path={`/${menuType}`}
                element={
                  <Store
                    storeType={convertMenuTypeToStoreType(menuType)}
                    subType={extractSubType(menuType)}
                  />
                }
              />
              <Route
                key={`${menuType}-review`}
                path={`/review/${menuType}/:id`}
                element={
                  <Review
                    storeType={convertMenuTypeToStoreType(menuType)}
                    subType={extractSubType(menuType)}
                  />
                }
              />
            </React.Fragment>
          ))}
        </Routes>
      </Container>
    </div>
  );
}

export default App;
